import _asyncToGenerator from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5edc5363"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "card"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "22px",
    "font-weight": "bold",
    "margin-bottom": "20px"
  }
}, " 万药通-欢迎登录 ", -1));

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 登录 ");

const _hoisted_5 = {
  class: "qr-code"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "code-title"
}, "扫码下载 万药通APP", -1));

const _hoisted_7 = ["src"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, null, -1));

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 取消 ");

const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 提交 ");

import { reactive, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import router from '@/router';
import { localSet, localGet, localRemove } from '@/utils';
import { ElMessage } from 'element-plus';
import ChangePwd from '@/components/ChangePwd.vue';
import testCodeImg from './img/qcode_test.png';
import ProdCodeImg from './img/qcode.png';
export default {
  name: 'Login',

  setup(__props) {
    let qrCodeUrl;

    if (process.env.environment === 'test') {
      qrCodeUrl = testCodeImg;
    } else {
      qrCodeUrl = ProdCodeImg;
    }

    const store = useStore();
    const formRef = ref();
    const remember = ref(true);
    const showChangePwdModal = ref(false);
    const changePwdRef = ref();
    const form = reactive({
      username: localGet('username') || '',
      pwd: localGet('pwd') || ''
    });
    const count = ref(1);

    const changeValue = () => {
      count.value += 1;
    };

    function remberPwd() {
      if (remember.value) {
        localSet('pwd', form.pwd);
      } else {
        localRemove('pwd');
      }
    }

    const login = () => {
      formRef.value.validate().then( /*#__PURE__*/_asyncToGenerator(function* () {
        const data = yield store.dispatch('user/login', form);
        remberPwd();

        if (data !== null && data !== void 0 && data.success) {
          // store.dispatch('router/getRouteList');
          router.push({
            name: 'ManagePage'
          });
        } else if (data !== null && data !== void 0 && data.isWeakPwd) {
          showChangePwdModal.value = true;
        } else {
          ElMessage.error(data.message || '用户名或密码错误');
        }
      }));
    };

    function submit() {
      changePwdRef.value.submit().then(() => {
        store.dispatch('user/initLoginState', form); // store.dispatch('router/getRouteList');

        router.push({
          name: 'ManagePage'
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
        style: {
          "width": "350px"
        },
        model: form,
        ref_key: "formRef",
        ref: formRef,
        onKeydown: _withKeys(login, ["enter"])
      }, {
        default: _withCtx(() => [_hoisted_3, _createVNode(_component_el_form_item, {
          prop: "username",
          rules: {
            required: true,
            message: '请输入用户名'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            size: "large",
            "prefix-icon": "User",
            modelValue: form.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.username = $event),
            clearable: "",
            placeholder: "请输入用户名"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "pwd",
          rules: {
            required: true,
            message: '请输入密码'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            size: "large",
            "prefix-icon": "Lock",
            modelValue: form.pwd,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.pwd = $event),
            type: "password",
            placeholder: "请输入密码",
            clearable: "",
            "show-password": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_row, {
          justify: "start"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            modelValue: remember.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => remember.value = $event),
            label: "记住密码"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_button, {
          style: {
            "width": "100%",
            "margin-top": "20px"
          },
          type: "primary",
          onClick: login,
          size: "large"
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "onKeydown"]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("img", {
        style: {
          "width": "220px",
          "height": "220px"
        },
        src: _unref(qrCodeUrl),
        alt: ""
      }, null, 8, _hoisted_7)])]), _hoisted_8, _createVNode(_component_el_dialog, {
        title: "提示",
        modelValue: showChangePwdModal.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => showChangePwdModal.value = $event)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => showChangePwdModal.value = false)
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_alert, {
          title: "您的登录密码安全系数较低，存在数据泄露风险，请立即修改",
          type: "error",
          style: {
            "margin-bottom": "10px"
          }
        }), _createVNode(ChangePwd, {
          username: form.username,
          hideOldPwd: true,
          ref_key: "changePwdRef",
          ref: changePwdRef
        }, null, 8, ["username"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};